// eslint-disable-next-line import/prefer-default-export
export const REPLICATION_DELAY = 600;
